"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const model_1 = require("./model");
const template_html_1 = __importDefault(require("./template.html"));
require("./style.less");
const register_component_1 = require("@/utils/engine/register-component");
(0, register_component_1.registerComponent)('fc-nps-item', { model: model_1.ViewModel, template: template_html_1.default });
